import React, {Component} from 'react';
import {Table, Button} from 'reactstrap';
import './AccreditationGroupsList.css';
import PropTypes from 'prop-types';
import {
    Redirect
} from "react-router-dom";
import _ from 'lodash';
import {sharedLabelsPath} from "../../../reducers/common/localization";
import CreateAccreditationGroupModal from "../AccreditationGroupModal/CreateAccreditationGroupModal/CreateAccreditationGroupModal.container";
import IconContainer from '../../commonComponents/iconContainer/IconContainer';
import RemoveAccreditationGroupModal from "../AccreditationGroupModal/RemoveAccreditationGroupModal/RemoveAccreditationGroupModal.container";
import PaginationAccreditationGroups from "../../commonComponents/paginationComponent/PaginationAccreditationGroups.container";
import {Utils} from '../../../utils/utils';

const SUCCESS_MESSAGE_BY_ACTION = {
    ADD: 'org_staff.accreditation_groups.create_accreditation_group_success_message',
    REMOVE: 'org_staff.accreditation_groups.remove_group_success_message'
};

class AccreditationGroupsList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            groupToRemove: null,
            groupIsSelected: false,
        }
    }

    render() {
        return (
            <div className='accreditation-groups-list-container'>
                    <h4 className='page-label'>{_.get(this.props.translation, 'org_staff.accreditation_groups.table_label')}</h4>
                    <div className="accreditation-groups-list-hint-container"
                         hidden={_.isNil(this.props.data) || this.props.data.length === 0}>
                        {Utils.getTagsFromStringWithStyles(_.get(this.props.translation, 'accreditation_requests.accreditation_group_hint'))}
                    </div>
                    <div className="accreditation-groups-list-hint-container"
                         hidden={_.isNil(this.props.data) || this.props.data.length === 0 || (_.every(this.props.data, el => el.inserterCount > 0 && el.validatorCount > 0))}>
                        {_.get(this.props.translation, 'org_staff.accreditation_groups.no_staff_assigned_label')}
                    </div>
                    <div className='add-accreditation-group-button-container'>
                        <Button className='add-accreditation-group-button olive-green-btn'
                                onClick={this.handleAddButtonClick}>
                            {_.get(this.props.translation, sharedLabelsPath.add_button)}
                        </Button>
                    </div>

                    <PaginationAccreditationGroups/>
                    {this.renderContent()}

                    <CreateAccreditationGroupModal/>
                    <RemoveAccreditationGroupModal data={this.state.groupToRemove}
                                                   onCancelRemoving={this.handleCancelRemoving}/>
                    {this.state.groupIsSelected && !_.isNil(this.props.groupId) ?
                        <Redirect to={'/accreditation-group?id=' + this.props.groupId} push/> : null}
            </div>
        );
    }

    renderContent() {
        if (this.props.loading) {
            return (
                <div className="accreditation-groups-list-status-message-container">
                    <h6>{_.get(this.props.translation, sharedLabelsPath.fetching_message)}</h6>
                </div>
            );
        }
        if (_.isNil(this.props.data) || this.props.data.length === 0) {
            return this.renderHint();
        }
        return (
            <Table className='accreditation-groups-list-table'>
                <thead>
                <tr>
                    <th>{_.get(this.props.translation, 'org_staff.accreditation_groups.accreditation_group_name_label')}</th>
                    <th className="text-center">{_.get(this.props.translation, 'org_staff.accreditation_groups.inserters_label')}</th>
                    <th className="text-center">{_.get(this.props.translation, 'org_staff.accreditation_groups.validators_label')}</th>
                    <th/>
                    <th/>
                </tr>
                </thead>
                <tbody>
                {this.renderAccreditationGroupData()}
                </tbody>
            </Table>
        )
    }

    renderHint = () => {
        return (
            <div className="accreditation-groups-list-placeholder">
                <div className="accreditation-groups-list-status-message-container">
                    <h5>
                        {Utils.getTagsFromStringWithStyles(
                            _.get(this.props.translation, 'org_staff.accreditation_groups.no_data_label')
                        )}
                    </h5>
                </div>
                <div>
                    {Utils.getTagsFromStringWithStyles(
                        _.get(this.props.translation, 'org_staff.accreditation_groups.accreditation_groups_definition_label')
                    )}
                </div>
                <div>
                    {_.get(this.props.translation, sharedLabelsPath.examples_label)}:
                </div>
                <ul>
                    {_.map(
                        _.get(this.props.translation, 'org_staff.accreditation_groups.accreditation_group_examples_label').split(';'),
                        (example, index) => (<li key={'example' + index}>{example}</li>)
                    )}
                </ul>
                <div>
                    {Utils.getTagsFromStringWithStyles(
                        _.get(this.props.translation, 'org_staff.accreditation_groups.different_from_departments_label') + " "
                    )}
                    -
                    {Utils.getTagsFromStringWithStyles(
                        " " + _.get(this.props.translation, 'org_staff.departments.departments_definition_label_uni')
                    )}
                </div>
                <div>
                    {_.get(this.props.translation, sharedLabelsPath.examples_label)}:
                </div>
                <ul>
                    {_.map(
                        _.get(this.props.translation, 'org_staff.departments.departments_examples_label').split(';'),
                        (example, index) => (<li key={'example' + index}>{example}</li>)
                    )}
                </ul>
                <div>
                    {Utils.getTagsFromStringWithStyles(
                        " " + _.get(this.props.translation, 'org_staff.departments.departments_definition_label_part_2')
                    )}
                </div>
            </div>
        );
    };

    componentDidMount() {
        this.props.onMount();
    }

    renderAccreditationGroupData() {
        return _.map(this.props.data, (accreditationGroup, index) => {
            return (
                <tr key={index} className="accreditation-groups-table-row">
                    <td className="accreditation-group-name-td"
                        data-th={_.get(this.props.translation, 'org_staff.accreditation_groups.accreditation_group_name_label') + ":"}
                        onClick={this.handleTableRowClick(accreditationGroup.id)}>
                        {accreditationGroup.name}
                    </td>
                    <td className={"accreditation-group-inserters-td " + (accreditationGroup.inserterCount === 0 ? 'empty' : '')}
                        title={(accreditationGroup.inserterCount === 0 ? _.get(this.props.translation, 'org_staff.accreditation_groups.no_inserters_label') : '')}
                        data-th={_.get(this.props.translation, 'org_staff.accreditation_groups.inserters_label') + ":"}
                        onClick={this.handleTableRowClick(accreditationGroup.id)}>
                        {accreditationGroup.inserterCount}
                    </td>
                    <td className={"accreditation-group-validators-td " + (accreditationGroup.validatorCount === 0 ? 'empty' : '')}
                        title={(accreditationGroup.validatorCount === 0 ? _.get(this.props.translation, 'org_staff.accreditation_groups.no_validators_label') : '')}
                        data-th={_.get(this.props.translation, 'org_staff.accreditation_groups.validators_label') + ":"}
                        onClick={this.handleTableRowClick(accreditationGroup.id)}>
                        {accreditationGroup.validatorCount}
                    </td>
                    <td className="control-cell create-group-icon-td"
                        onClick={this.handleTableRowClick(accreditationGroup.id)}>
                        <IconContainer
                            key={index}
                            icon='create'
                            className="create-group-icon"
                            title={_.get(this.props.translation, sharedLabelsPath.edit_button)}
                        />
                    </td>
                    <td className="control-cell remove-group-icon-td">
                        <IconContainer
                            key={index}
                            icon='trash'
                            className="remove-group-icon"
                            title={_.get(this.props.translation, sharedLabelsPath.remove_button)}
                            onClick={this.handleRemoveAccreditationGroup(accreditationGroup)}
                        />
                    </td>
                </tr>
            )
        })
    }

    handleAddButtonClick = () => {
        this.props.onAddButtonClick();
        this.props.setSuccessMessage(SUCCESS_MESSAGE_BY_ACTION.ADD);
    };

    handleTableRowClick = (id) => () => {
        this.props.onAccreditationGroupSelect(id);
        this.setState({groupIsSelected: true});
    };

    handleRemoveAccreditationGroup = (group) => () => {
        this.props.onAccreditationGroupRemove();
        this.props.setSuccessMessage(SUCCESS_MESSAGE_BY_ACTION.REMOVE);
        this.setState({groupToRemove: group});
    };

    handleCancelRemoving = () => {
        this.setState({groupToRemove: null});
    };

}

AccreditationGroupsList.propTypes = {
    data: PropTypes.array,
    loading: PropTypes.bool,
    translation: PropTypes.object,
    onAddButtonClick: PropTypes.func,
    onMount: PropTypes.func,
    onAccreditationGroupSelect: PropTypes.func,
    onAccreditationGroupRemove: PropTypes.func,
    setSuccessMessage: PropTypes.func.isRequired
};

export default AccreditationGroupsList;



// WEBPACK FOOTER //
// ./src/components/staffMemberManagement/AccreditationGroupsList/AccreditationGroupsList.js